import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../../components/UI Component/Modal/commonModals.css";
import slugicon from "../../assets/newslugicon.svg";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import Loader from "../UI Component/Loader/Loader";

const Shareconfirm = ({
  show,
  data,
  name,
  slug,
  handleClose,
  handleBack,
  opensent,
  smsBody,
  phone,
}) => {
  const [loading, setloading] = useState(false);
  const handleMessageSend = () => {
    let url = `${window.location.origin}/doctor/` + slug;
    setloading(true);
    const customisedMessage =
      `${name?.trim()}` +
      " is now available online to consult. Please visit the url" +
      " " +
      url +
      " " +
      "to consult.";
    const customisedEmailMessage = `<html>
    <p >Dear Sir/Madam,</p>
  <br/>
    <p style="line-height:1%">Hope you are doing well. This is ${name}.</p>
    <p >
      Kindly use this link to book an appointment with me <br />
      <a href=${url} target="_blank">
        ${slug}
      </a>
    </p>
  <br/>
    <p style="line-height:1%">Warm Regards,</p>
    <p >${name}</p>
    <p style="line-height:1%">${phone}</p>
    </html>
    `;

    // this.setState({ share: false });
    // this.setState({ loading: true });
    if (smsBody) {
      afterLoginApiAxios({
        method: "post",
        url: "/doctor/send-sms",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: data.token,
        },
        data: {
          "authorizer-principal-id": {
            user_type: "1",
          },
          doctor_id: data.doctor_id,
          preset_message: data.preset_message,
          message_body: customisedMessage,
          url: url,
          request: data.request,
        },
      }).then((response) => {
        setloading(false);
        // this.setState({ loading: false });
        if (response.data.statusCode == 200) {
          // this.toggleSlugModal();
          handleClose();
          opensent();
        } else {
          swal({
            title: "Message Not Sent",
            text: "Some error occured",
            type: "error",
            icon: "warning",
          });
        }
      });
    } else {
      afterLoginApiAxios({
        method: "post",
        url: "/doctor/post-care-email",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: data.token,
        },
        data: {
          // "authorizer-principal-id": {
          //   user_type: "1",
          // },
          doctor_id: data.doctor_id,
          email_body: customisedEmailMessage,
          patient_email: data.request,
        },
      }).then((response) => {
        setloading(false);
        if (response.data[0].statusCode == 200) {
          handleClose();
          opensent();
        } else {
          swal({
            title: "Message Not Sent",
            text: "Some error occured",
            type: "error",
            icon: "warning",
          });
        }
      });
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
      {show ? (
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          animation={false}
          centered
        >
          <Modal.Body className="p-2 my-2 mx-2">
            <div className="slug-message-sent">
              <div className=" text-center mb-3 mt-3 ">
                <img src={slugicon} style={{ height: "70px", width: "72px" }} />
                <p
                  className="my-2"
                  style={{ fontWeight: "bold", fontSize: "25px" }}
                >
                  Share Link
                </p>
                <p className="text-break " style={{ fontSize: "15px" }}>
                  Are you sure you want to share your Booking Appointment Link?{" "}
                </p>
              </div>

              <div className="container text-center mb-3">
                <div className="row px-5 justify-content-center ">
                  <div className="col px-0  mb-sm-2 ">
                    <Button
                      className="btn btn-lg border-0 mb-md-2  border rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                      onClick={handleMessageSend}
                    >
                      Yes
                    </Button>
                  </div>

                  <div className="col px-0  ">
                    <Button
                      className="btn btn-lg border   rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#fff", color: "#17BAE0" }}
                      onClick={handleBack}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};

export default Shareconfirm;
